import { NavListContext, NavShowContext } from 'App';
import BottomNav from 'components/frame/bottom-nav';
import TitleNav from 'components/frame/title-nav';
import Top1Nav from 'components/frame/top1-nav';
import Top2Nav from 'components/frame/top2-nav';
import { useContext, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { TermsNodeListDT } from 'services/apis/cnt2/term-api';
import { useWindowSize } from 'usehooks-ts';
import { isEmpty } from 'utils/listUtil';

const PageOne = () => {
  const navList = useContext(NavListContext).navList;
  const updateNavList = useContext(NavListContext).updateNavList;
  const windowSize = useWindowSize();
  const navShowState = useContext(NavShowContext).navShowState;
  const updateNavShowState = useContext(NavShowContext).updateNavShowState;

  return (
    <>
      <div className=" relative">
        <div className=" sticky top-0 z-10">
          {/* 标题导航 */}
          {navShowState.showTitleNav && <TitleNav />}
          {/* 一级导航 */}
          {navShowState.showTop1Nav && navList.top1TermList.length !== 0 && (
            <Top1Nav
              onClick={(key) => {
                // 一级导航
                const _top1TermNow = navList.top1TermList.find((item) => item.termUuid === key) as TermsNodeListDT;
                // 二级导航
                const _top2TermList = isEmpty(_top1TermNow.termsNodeList) ? [] : _top1TermNow.termsNodeList;
                // 更新导航
                updateNavList((draft) => {
                  draft.top2TermList = _top2TermList;
                  draft.top1TermNow = _top1TermNow;
                  draft.top2TermNow = _top2TermList[0];
                });
              }}
            />
          )}
          {/* 二级导航 */}
          {navShowState.showTop2Nav && navList.top2TermList.length !== 0 && (
            <Top2Nav
              onClick={(key) => {
                // 二级导航
                const _top2TermNow = navList.top2TermList.find((item) => item.termUuid === key);
                // 更新导航
                updateNavList((draft) => {
                  draft.top2TermNow = _top2TermNow;
                });
              }}
            />
          )}
        </div>
        <Outlet />
        {/* 底部导航 */}
        {navShowState.showBottomNav && (
          <>
            {/* 底部占位 */}
            <div className=" my-16 invisible">底部占位</div>
            <BottomNav
              onClick={(key) => {
                // 底部导航
                const _btmTermNow = navList.btmTermList.find((item) => item.termUuid === key);
                // 一级导航
                const _top1TermList = isEmpty(_btmTermNow?.termsNodeList) ? [] : _btmTermNow?.termsNodeList;
                // 二级导航
                const _top2TermList = isEmpty(_top1TermList) ? [] : _top1TermList[0].termsNodeList;
                // 更新导航
                updateNavList((draft) => {
                  draft.top1TermList = _top1TermList;
                  draft.top2TermList = _top2TermList;
                  draft.btmTermNow = _btmTermNow;
                  draft.top1TermNow = _top1TermList[0];
                  draft.top2TermNow = _top2TermList[0];
                });
              }}
              className={[' fixed bottom-0 w-full', ' w-[' + windowSize.width + ']'].join(' ')}
            />
          </>
        )}
      </div>
    </>
  );
};

export default PageOne;
